import { render, staticRenderFns } from "./CreateNew.vue?vue&type=template&id=5830a2e5"
import script from "./CreateNew.vue?vue&type=script&lang=js"
export * from "./CreateNew.vue?vue&type=script&lang=js"
import style0 from "./CreateNew.vue?vue&type=style&index=0&id=5830a2e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports